<ng-container *ngIf="props.skeletonType === 'input'">
  <div class="skeleton__label">
    <ispui-skeleton *ngIf="props.isHaveLabel" [show]="true"></ispui-skeleton>
  </div>
  <div class="skeleton__wrapper">
    <ispui-skeleton
      [show]="true"
      class="skeleton__input"
      [class.skeleton__fullwidth]="props.isFullWidth"
    >
    </ispui-skeleton>
    <ispui-skeleton
      *ngIf="props.isHaveHint"
      [show]="true"
      class="skeleton__hint"
    >
    </ispui-skeleton>
  </div>
</ng-container>

<ng-container *ngIf="props.skeletonType === 'textarea'">
  <div class="skeleton__label">
    <ispui-skeleton *ngIf="props.isHaveLabel" [show]="true"></ispui-skeleton>
  </div>
  <div class="skeleton__wrapper">
    <ispui-skeleton
      [show]="true"
      class="skeleton__textarea"
      [class.skeleton__fullwidth]="props.isFullWidth"
    >
    </ispui-skeleton>
    <ispui-skeleton
      *ngIf="props.isHaveHint"
      [show]="true"
      class="skeleton__hint"
    >
    </ispui-skeleton>
  </div>
</ng-container>

<ng-container *ngIf="props.skeletonType === 'checkbox'">
  <div class="skeleton__wrapper">
    <ispui-skeleton [show]="true" class="skeleton__hint"> </ispui-skeleton>
    <ispui-skeleton [show]="true" class="skeleton__caption"> </ispui-skeleton>
    <ispui-skeleton
      *ngIf="props.isHaveHint"
      [show]="true"
      class="skeleton__hint"
    >
    </ispui-skeleton>
  </div>
</ng-container>
